/* Geteilter Helfer: dem Theme einen VOLLSTAENDIGEN Warenkorb melden (23.09.2026)
 * ==============================================================================
 * Alle eigenen Editoren rufen `/cart/add.js` selbst und sagen dem Theme danach Bescheid.
 * Bis heute geschah das so:
 *
 *     document.dispatchEvent(new CustomEvent('cart:change', { detail: { cart: <add.js-Antwort> } }));
 *     document.dispatchEvent(new CustomEvent('cart:refresh'));
 *
 * Die Antwort von add.js ist aber KEIN Warenkorb, sondern nur die eingelegte Zeile. Prestige
 * erwartet in `cart:change` mehr, und zwar an zwei Stellen (theme.js):
 *
 *   CartDrawer.onCartChange_fn   liest  event.detail.cart.sections[<Section-ID des Drawers>]
 *   free-shipping-bar            liest  event.detail.cart.items[] und .cart_level_discount_applications
 *
 * Beides fehlt in der add.js-Antwort. Ergebnis war bei JEDEM Einlegen ein TypeError in der
 * Konsole („Cannot read properties of undefined"). Der Drawer oeffnete trotzdem, weil direkt
 * danach `cart:refresh` kam — der Fehler war also folgenlos, aber laut, und er hat jede
 * Konsolen-Diagnose zugemuellt (Befund 12.09.2026, wieder gesehen beim Live-Gang 20.09.2026).
 *
 * Diese Datei macht es so, wie Prestige es selbst macht:
 *   1. `cart:prepare-bundled-sections` feuern. Jede Section, die neu gezeichnet werden will,
 *      traegt ihre ID in `detail.sections` ein (der Drawer tut das immer).
 *   2. Parallel `/cart.js` (der echte Warenkorb) und `/?sections=<ids>` (das HTML der Sections)
 *      holen. Beides sind Shopify-Bordmittel und brauchen keine Aenderung am add.js-Aufruf.
 *   3. `cart:change` mit `{ cart: <voller Warenkorb> + sections }` feuern, danach `cart:refresh`.
 *
 * Vorsichtsregeln, absichtlich streng:
 *   - `cart:change` wird NUR gefeuert, wenn beide Teile da sind. Fehlt etwas (Netzfehler,
 *     Seite ohne Drawer), bleibt es beim alten, funktionierenden `cart:refresh` allein. Ein
 *     halb gefuelltes Ereignis waere genau der Fehler, den diese Datei abschafft.
 *   - `detail.baseEvent` wird NICHT gesetzt. Damit oeffnet Prestige den Drawer nicht selbst;
 *     das machen die Editoren wie bisher am Ende ihrer eigenen Kette. So aendert sich am
 *     sichtbaren Ablauf nichts, nur der Fehler verschwindet.
 *   - Der Aufruf wirft nie. Ein gemeldeter Warenkorb darf einen erfolgreichen Kauf nie gefaehrden.
 *
 * Einbindung: klassisches Skript im Layout (neben cart-edit.js), also auf jeder Seite als
 * `window.DLCartMelden` verfuegbar — auch fuer die Poster-Editoren, wenn sie nachziehen.
 */
(function () {
  'use strict';

  function wurzel() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  /* Section-IDs einsammeln, die beim naechsten Warenkorb-Wechsel neu gezeichnet werden wollen.
     Prestige haengt den Drawer selbst an dieses Ereignis (CartDrawer.onBundleSection_fn). */
  function abschnittsIds() {
    var ids = [];
    try {
      document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
        bubbles: true,
        detail: { sections: ids },
      }));
    } catch (e) { /* ohne Drawer bleibt die Liste leer, das ist kein Fehler */ }
    return ids.filter(function (id, i) { return id && ids.indexOf(id) === i; });
  }

  function holeJson(pfad) {
    return fetch(pfad, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  /* nachAdd() — nach einem erfolgreichen /cart/add.js aufrufen. Gibt den vollen Warenkorb
     zurueck (oder null), damit der Aufrufer ihn weiterverwenden kann, statt ihn erneut zu holen. */
  function nachAdd() {
    var ids = abschnittsIds();
    return Promise.all([
      holeJson(wurzel() + 'cart.js'),
      ids.length ? holeJson(wurzel() + '?sections=' + encodeURIComponent(ids.join(','))) : Promise.resolve(null),
    ]).then(function (teile) {
      var warenkorb = teile[0];
      var abschnitte = teile[1];
      if (warenkorb && abschnitte && Object.keys(abschnitte).length) {
        warenkorb.sections = abschnitte;
        document.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { cart: warenkorb } }));
      }
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      return warenkorb;
    }).catch(function () {
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      return null;
    });
  }

  window.DLCartMelden = { nachAdd: nachAdd };
})();
